import $ from 'jquery';
import {NOTIFICATIONS} from "Core/links";

const renew = (socket) => {
    $.get(NOTIFICATIONS, (response) => {
        const notificationWrapper = $('.header-notifications__items-wrapper');
        const iconWrapper = $('.header-notifications__icon-wrapper');
        const notificationBadge = $('.header-notifications__badge');

        if (response !== null) {
            notificationWrapper.html(response.items);
            notificationBadge.remove();
            iconWrapper.append(response.total);
        }
    }, 'json');
};

export default renew;
